import { IconArrowRight } from '@tabler/icons-react'
import { Button } from 'components/Button'
import React from 'react'

interface MarketingHeroProps {
  title: string | null
  description: string | null
}

export const MarketingHero: React.FC<MarketingHeroProps> = ({
  title,
  description,
}) => {
  return (
    <div className="relative w-full">
      {/* Background decorative circles */}
      <div className="absolute -left-4 top-1/2 h-24 w-24 -translate-y-1/2 transform rounded-full bg-gradient-to-br from-indigo-100/30 to-indigo-50/30 opacity-50 blur-xl" />
      <div className="absolute -right-4 top-1/2 h-32 w-32 -translate-y-1/2 transform rounded-full bg-gradient-to-br from-purple-100/30 to-purple-50/30 opacity-50 blur-xl" />

      <div className="relative z-10 flex max-w-4xl flex-col items-start">
        <div className="flex items-center gap-4">
          <div className="relative flex flex-col gap-2 lg:flex-row lg:items-center">
            <h1 className="font-jakarta text-3xl tracking-tight text-toasty-blue-700">
              {title} Prompt Pack
            </h1>
            <div>
              <Button
                icon={IconArrowRight}
                iconPosition="right"
                size="md"
                href={`/register`}
                className="sm:hidden"
              >
                Use this pack
              </Button>
              <Button
                icon={IconArrowRight}
                iconPosition="right"
                size="xs"
                href={`/register`}
                className="hidden sm:inline-flex"
              >
                Use this pack
              </Button>
            </div>
          </div>
        </div>
        <p className="mt-2 max-w-3xl text-xl font-normal leading-relaxed text-gray-600">
          {description}
        </p>
      </div>
    </div>
  )
}
